import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getShopby } from "../services/shopby.service";
import useShopBy from "../hooks/useShopby";

function ShopBy() {
  const [rawData, setRawData] = useState({});
  const [active, setActive] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getShopby();
      setRawData(data);
    };
    fetchData();
  }, []);

  const shopByItems = useShopBy(rawData);

  if (!shopByItems.length) return null;

  return (
    <section className="shopby">
      <p className="shopby-title text-uppercase mb-4 txt_shopby">
        Shop by
      </p>

      <ul className="shopby-list">
  {shopByItems.map((item, i) => (
    <li
      key={item.id}
      className={`shopby-item 
        ${item.sale ? "sale" : ""} 
        ${active === i ? "is-active" : ""}
        ${item.label === "End Of Seasonal Sale" ? "season-sale" : ""}
      `}
      onMouseEnter={() => setActive(i)}
      onMouseLeave={() => setActive(null)}
    >
      <Link to={item.url}>
        <div className="thumb-bar">
          {item.thumbs.map((src, idx) => (
            <div key={idx} className="thumb">
              <img src={src} alt={item.label} />
            </div>
          ))}
        </div>

        <span className="shopby-label">{item.label}</span>
        <span className="view-tag">View</span>
      </Link>
    </li>
  ))}
</ul>
    </section>
  );
}
export default ShopBy;